@use '@fukuri-admins/ui/layout' as *;

.card {
  padding: 16px;
  text-align: left;
  border: solid 1px #E5E5E5;
  border-radius: 16px;
  background-color: $NATURAL_600;
  width: 280px;

  @media screen and (max-width: $TB) {
    background-color: background('Primary');
  }
}

.date {
  font-size: 20px;
  margin-bottom: 5px;
  color: white;

  @media screen and (max-width: $TB) {
    font-size: 14px;
    font-weight: 700;
    color: text('High');
  }
}

.label {
  font-size: 14px;
  color: #A3A3A3;
  margin-bottom: 5px;

  @media screen and (max-width: $TB) {
    font-size: 12px;
    font-weight: 700;
  }
}

.amount {
  font-size: 20px;
  color: white;

  @media screen and (max-width: $TB) {
    color: text('High');
    font-weight: 700;
  }
}
